export default "__VITE_ASSET__B$qkhnKm__"